import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import API_URL from "../config/config";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);
  // true while we're checking the JWT cookie on mount — route guards must wait
  const [authLoading, setAuthLoading] = useState(true);

  const login = (userClaims, name = null) => {
    setUser(userClaims);
    if (name) setUserName(name);
  };

  const logout = () => {
    setUser(null);
    setUserName(null);
  };

  // On every fresh page load, attempt to restore auth state from the httpOnly
  // JWT cookie via /user/me. If the cookie is valid, we skip the redirect to
  // /login entirely. If not, authLoading flips to false and route guards redirect.
  useEffect(() => {
    axios
      .get(`${API_URL}/user/me`, { withCredentials: true })
      .then((res) => {
        setUser(res.data);
      })
      .catch(() => {
        // Cookie absent or expired — user must log in
      })
      .finally(() => {
        setAuthLoading(false);
      });
  }, []);

  return (
    <AuthContext.Provider value={{ user, userName, authLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
